import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBeta: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBeta"><Path d="M7.66331 14.0882V8.26471C7.66331 5.63323 9.84255 3.5 12.5308 3.5C18.0188 3.5 18.5 11 12.5 11M7.66331 14.0882V19.3367C7.66331 20.5315 6.69476 21.5 5.5 21.5M7.66331 14.0882C7.66331 17.0121 9.53077 19.5 12.5308 19.5C19 19.5 19 11 13 11" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBeta;
